<ng-container *ngIf="isReady$ | async; else loadingTmpl">
  <rd-core-main-container #container>
    <rd-anz-bypass-block
      bypass-block
      [isLoggedIn]="container.isLoggedIn$ | async"></rd-anz-bypass-block>
    <rd-anz-desktop-header
      main-header
      role="header"
      aria-label="site header"
      tabindex="-1"></rd-anz-desktop-header>
    <rd-anz-footer main-footer></rd-anz-footer>
  </rd-core-main-container>
</ng-container>

<ng-template #loadingTmpl>
  <div class="flex h-screen w-screen items-center justify-center">
    <rd-shared-spinner></rd-shared-spinner>
  </div>
</ng-template>
